import React from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";
import reduxStore from "../../configureEnvStore";
import { setMeasurementStatusPopup } from "../../reducers/measurement-reducer";
import PrepareMeasurementView from "./PrepareMeasurementView";
import MeasurementARStatusModal from "./MeasurementARStatusModal";
import MeasurementAppRequiredModal from "./MeasurementAppRequiredModal";
import MeasurementMenubar from "./MeasurementMenubar";
import MeasurementListDrawer from "./MeasurementListDrawer";
import { MEASUREMENT_VIEW } from "../../constants/Constants";
import { GLOBAL_MEETING_DATA } from "../../constants/PublicVariables";
import { AR_MEASUREMENT_ACTION } from "../../constants/MeasurementConstants";

const Measurement = () => {
    const { measurementView, showMeasurementToastPopup, measurementToastMsgStatus, measurementStatusPopup } = useSelector(
        (state) => state.measurement
    );

    const handleCloseModal = () => {
        reduxStore.dispatch(setMeasurementStatusPopup(""));
    };

    return (
        <>
            {measurementView === MEASUREMENT_VIEW.PREPARE_VIEW && (
                <PrepareMeasurementView showPrepareView={measurementView === MEASUREMENT_VIEW.PREPARE_VIEW} />
            )}
            {measurementStatusPopup === AR_MEASUREMENT_ACTION.SUPPORTED_READY_TO_START && (
                <>
                    <div
                        className={clsx("annotation-modal ar-measurement", measurementView === MEASUREMENT_VIEW.START_MEASUREMENT_VIEW && "active")}
                        id='measurement-annotation'
                    >
                        <div className='annotation-modal-content'>
                            <div className='annotation-modal-body'>
                                {showMeasurementToastPopup && GLOBAL_MEETING_DATA.isAgent && (
                                    <div className='ar-measurement-toast'>
                                        <div className='ar-measurement-toast-in'>
                                            {measurementToastMsgStatus && <span>{measurementToastMsgStatus}</span>}
                                        </div>
                                    </div>
                                )}
                                <div className='annotation-canvas-box' id='measurementCanvasContainer'></div>
                            </div>
                            <div className='annotation-action-menu'>
                                <MeasurementMenubar />
                            </div>
                        </div>
                    </div>
                    {GLOBAL_MEETING_DATA.isAgent && <MeasurementListDrawer />}
                </>
            )}
            {measurementStatusPopup === AR_MEASUREMENT_ACTION.NOT_SUPPORT_AR && (
                <MeasurementARStatusModal
                    actionType={AR_MEASUREMENT_ACTION.NOT_SUPPORT_AR}
                    modalTitleKey={"device_not_compatible_for_measurement"}
                    modalBodyKey={"device_not_support_google_play_service"}
                    isARNotSupportedLink
                    handleCloseModal={handleCloseModal}
                />
            )}
            {measurementStatusPopup === AR_MEASUREMENT_ACTION.APP_NOT_INSTALLED && (
                <MeasurementARStatusModal
                    actionType={AR_MEASUREMENT_ACTION.APP_NOT_INSTALLED}
                    modalTitleKey={"app_required_for_measurement"}
                    modalBodyKey={"device_required_google_play_service"}
                    handleCloseModal={handleCloseModal}
                />
            )}
            {measurementStatusPopup === AR_MEASUREMENT_ACTION.NEEDS_TO_UPDATE_APP && (
                <MeasurementARStatusModal
                    actionType={AR_MEASUREMENT_ACTION.NEEDS_TO_UPDATE_APP}
                    modalTitleKey={"app_required_update_for_measurement"}
                    modalBodyKey={"device_required_update_google_play_service"}
                    handleCloseModal={handleCloseModal}
                />
            )}
            {/* Measurement popup for MWeb  */}
            <MeasurementAppRequiredModal />
        </>
    );
};

export default Measurement;
